/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

/**
 * All of the possible `ConsoleResponseCode*`'s.
 */
export type ConsoleResponseCode =
  | ConsoleResponseCodeError
  | ConsoleResponseCodeFail
  | ConsoleResponseCodeForbidden
  | ConsoleResponseCodeNoContent
  | ConsoleResponseCodeNotFound
  | ConsoleResponseCodeSuccess
  | ConsoleResponseCodeUnauthorized;

/**
 * All of the possible `ConsoleResponseMessage*`'s.
 */
export type ConsoleResponseMessage =
  | ConsoleResponseMessageError
  | ConsoleResponseMessageFail
  | ConsoleResponseMessageForbidden
  | ConsoleResponseMessageNoContent
  | ConsoleResponseMessageNotFound
  | ConsoleResponseMessageSuccess
  | ConsoleResponseMessageUnauthorized;

/**
 * The error response code type.
 * @export
 */
export type ConsoleResponseCodeError = typeof CONSOLE_RESPONSE_CODE_ERROR;

/**
 * The fail response code type.
 * @export
 */
export type ConsoleResponseCodeFail = typeof CONSOLE_RESPONSE_CODE_FAIL;

/**
 * The forbidden response code type.
 * @export
 */
export type ConsoleResponseCodeForbidden = typeof CONSOLE_RESPONSE_CODE_FORBIDDEN;

/**
 * The no content response code type.
 * @export
 */
export type ConsoleResponseCodeNoContent = typeof CONSOLE_RESPONSE_CODE_NO_CONTENT;

/**
 * The not found response code type.
 * @export
 */
export type ConsoleResponseCodeNotFound = typeof CONSOLE_RESPONSE_CODE_NOT_FOUND;

/**
 * The success response code type.
 * @export
 */
export type ConsoleResponseCodeSuccess = typeof CONSOLE_RESPONSE_CODE_SUCCESS;

/**
 * The unauthorized response code type.
 * @export
 */
export type ConsoleResponseCodeUnauthorized = typeof CONSOLE_RESPONSE_CODE_UNAUTHORIZED;

/**
 * The error response message type.
 * @export
 */
export type ConsoleResponseMessageError = typeof CONSOLE_RESPONSE_MESSAGE_ERROR;

/**
 * The fail response message type.
 * @export
 */
export type ConsoleResponseMessageFail = typeof CONSOLE_RESPONSE_MESSAGE_FAIL;

/**
 * The forbidden response message type.
 * @export
 */
export type ConsoleResponseMessageForbidden = typeof CONSOLE_RESPONSE_MESSAGE_FORBIDDEN;

/**
 * The no content response message type.
 * @export
 */
export type ConsoleResponseMessageNoContent = typeof CONSOLE_RESPONSE_MESSAGE_NO_CONTENT;

/**
 * The not found response message type.
 * @export
 */
export type ConsoleResponseMessageNotFound = typeof CONSOLE_RESPONSE_MESSAGE_NOT_FOUND;

/**
 * The success response message type.
 * @export
 */
export type ConsoleResponseMessageSuccess = typeof CONSOLE_RESPONSE_MESSAGE_SUCCESS;

/**
 * The unauthorized response message type.
 * @export
 */
export type ConsoleResponseMessageUnauthorized = typeof CONSOLE_RESPONSE_MESSAGE_UNAUTHORIZED;

/**
 * The error response code.
 * @export
 */
export const CONSOLE_RESPONSE_CODE_ERROR = 500;

/**
 * The fail response code.
 * @export
 */
export const CONSOLE_RESPONSE_CODE_FAIL = 400;

/**
 * The forbidden response code.
 * @export
 */
export const CONSOLE_RESPONSE_CODE_FORBIDDEN = 403;

/**
 * The no content response code.
 * @export
 */
export const CONSOLE_RESPONSE_CODE_NO_CONTENT = 204;

/**
 * The not found response code.
 * @export
 */
export const CONSOLE_RESPONSE_CODE_NOT_FOUND = 404;

/**
 * The success response code.
 * @export
 */
export const CONSOLE_RESPONSE_CODE_SUCCESS = 200;

/**
 * The unauthorized response code.
 * @export
 */
export const CONSOLE_RESPONSE_CODE_UNAUTHORIZED = 401;

/**
 * The error response message.
 * @export
 */
export const CONSOLE_RESPONSE_MESSAGE_ERROR = 'Internal Server Error';

/**
 * The fail response message.
 * @export
 */
export const CONSOLE_RESPONSE_MESSAGE_FAIL = 'Fail';

/**
 * The forbidden response message.
 * @export
 */
export const CONSOLE_RESPONSE_MESSAGE_FORBIDDEN = 'Forbidden';

/**
 * The no content response message.
 * @export
 */
export const CONSOLE_RESPONSE_MESSAGE_NO_CONTENT = 'No Content';

/**
 * The not found response message.
 * @export
 */
export const CONSOLE_RESPONSE_MESSAGE_NOT_FOUND = 'Instance Not Found';

/**
 * The success response message.
 * @export
 */
export const CONSOLE_RESPONSE_MESSAGE_SUCCESS = 'Success';

/**
 * The unauthorized response message.
 * @export
 */
export const CONSOLE_RESPONSE_MESSAGE_UNAUTHORIZED = 'Unauthorized to request';
